const noData = [null, '', undefined, 'null']
import ApiService from "@/common/api.service"
import moment from "moment"

const state = {
  organizationSettings: null,
  organizationSettingsErrors: null,
  organizationSettingsLoading: false,
  listingUrl: null,
};

const getters = {
  organizationSettings (state) {
    return state.organizationSettings
  },
  organizationSettingsLoading (state) {
    return state.organizationSettingsLoading
  },
  listingUrl (state) {
    return state.listingUrl
  },
  payPeriod (state) {
    if(state.organizationSettings) {
      return state.organizationSettings.pay_period || 'weekly'
    } else {
      return 'weekly'
    }
  },
  payPeriodName (state, getters) {
    const names = {
      'weekly': 'Weekly',
      'bi_weekly': 'Bi-weekly',
      'twice_per_month': 'Twice per month',
      'monthly': 'Monthly'
    }
    return names[getters.payPeriod]
  },
  payPeriodPer (state, getters) {
    const names = {
      'weekly': 'week',
      'bi_weekly': 'bi-weekly',
      'twice_per_month': 'twice per month',
      'monthly': 'month'
    }
    return names[getters.payPeriod]
  },
  payPeriodDays: (state, getters) => (selectedDate) => {
    let start = null
    let end = null
    let inputDate = selectedDate
    if (getters.payPeriod === 'weekly') {
      // console.log('weekly');
      if(!inputDate) { inputDate = moment().subtract(1, "w").format("YYYY[-]MM[-]DD")}
      start = moment(inputDate, "YYYY[-]MM[-]DD").startOf("isoWeek").format("YYYY[-]MM[-]DD")
      end = moment(inputDate, "YYYY[-]MM[-]DD").endOf("isoWeek").format("YYYY[-]MM[-]DD")
    }
    if (getters.payPeriod === 'twice_per_month') {
      // console.log('twice_per_month');
      if(!inputDate) { 
        inputDate = moment().format("YYYY[-]MM[-]DD")
        if (moment(inputDate, "YYYY[-]MM[-]DD").get('date') < 16) {
          start = moment(inputDate, "YYYY[-]MM[-]DD").subtract(1, "months").set('date', 16).format("YYYY[-]MM[-]DD")
          end = moment(inputDate, "YYYY[-]MM[-]DD").subtract(1, "months").endOf("month").format("YYYY[-]MM[-]DD")
        } else {
          start = moment(inputDate, "YYYY[-]MM[-]DD").startOf("month").format("YYYY[-]MM[-]DD")
          end = moment(inputDate, "YYYY[-]MM[-]DD").set('date', 15).format("YYYY[-]MM[-]DD")
        }
      } else {
        if (moment(inputDate, "YYYY[-]MM[-]DD").get('date') < 16) {
          start = moment(inputDate, "YYYY[-]MM[-]DD").startOf("month").format("YYYY[-]MM[-]DD")
          end = moment(inputDate, "YYYY[-]MM[-]DD").set('date', 15).format("YYYY[-]MM[-]DD")
        } else {
          start = moment(inputDate, "YYYY[-]MM[-]DD").set('date', 16).format("YYYY[-]MM[-]DD")
          end = moment(inputDate, "YYYY[-]MM[-]DD").endOf("month").format("YYYY[-]MM[-]DD")
        }
      }
    }
    if (getters.payPeriod === 'bi_weekly') {
      // console.log('bi_weekly');
      if(!inputDate) { inputDate = moment().subtract(2, "w").format("YYYY[-]MM[-]DD") }
      if(moment(inputDate, "YYYY[-]MM[-]DD").get('isoWeek') % 2 === 0) {
        start = moment(inputDate, "YYYY[-]MM[-]DD").startOf("isoWeek").format("YYYY[-]MM[-]DD")
      } else {
        start = moment(inputDate, "YYYY[-]MM[-]DD").subtract(1, "w").startOf("isoWeek").format("YYYY[-]MM[-]DD")
      }
      end = moment(start, "YYYY[-]MM[-]DD").add(1, "w").endOf("isoWeek").format("YYYY[-]MM[-]DD")
    }
    if (getters.payPeriod === 'monthly') {
      // console.log('monthly');
      if(!inputDate) { inputDate = moment().subtract(1, "months").format("YYYY[-]MM[-]DD")}
      start = moment(inputDate, "YYYY[-]MM[-]DD").startOf("month").format("YYYY[-]MM[-]DD")
      end = moment(inputDate, "YYYY[-]MM[-]DD").endOf("month").format("YYYY[-]MM[-]DD")
    }
    let days = []
    let diff = moment(end, "YYYY[-]MM[-]DD").diff(moment(start, "YYYY[-]MM[-]DD"), 'days')
    for (let i = 0; i <= diff; i++) {
      days[i] = moment(start)
        .add(i, "d")
        .format("YYYY[-]MM[-]DD");
    }
    return days
  },
  payPeriodStart: (state, getters) => (selectedDate) => {
    let days = getters.payPeriodDays(selectedDate)
    return days.length ? days[0] : ''
  },
  payPeriodEnd: (state, getters) => (selectedDate) => {
    let days = getters.payPeriodDays(selectedDate)
    return days.length ? days[days.length - 1] : ''
  },
  payPeriodStartEnd: (state, getters) => (selectedDate) => {
    let days = getters.payPeriodDays(selectedDate)
    return days.length ? `${days[0]} - ${days[days.length - 1]}` : ''
  }
}

const actions = {
  checkOrganizationSettings (context, mandatory) {
    return new Promise((resolve, reject) => {
      if (mandatory || context.state.organizationSettings === null) {
        context.commit('setOrganizationSettingsErrors', null)
        context.commit('setOrganizationSettingsLoading', true)
        
        ApiService.get("/organization_settings")
          .then(response => {
            let organization_settings = {}
            response.data.organization_settings.forEach(i => {
              organization_settings[i.key] = i.value;
            })
            context.commit('setOrganizationSettings', organization_settings)
            let listingUrl = response.data.listing_url
            context.commit('setListinUrl', listingUrl)
            context.commit('setOrganizationSettingsLoading', false)
            resolve(organization_settings)
          })
          .catch(error => {
            context.commit('setOrganizationSettingsErrors', [error])
            context.commit('setOrganizationSettingsLoading', false)
            reject(error)
          });
      } else {
        resolve(context.state.organizationSettings)
      }
    })
  }
}

const mutations = {
  setOrganizationSettings (state, settings) {
    state.organizationSettings = settings
  },
  setListinUrl (state, listingUrl) {
    state.listingUrl = listingUrl
  },
  setOrganizationSettingsErrors (state, errors) {
    state.organizationSettingsErrors = errors
  },
  setOrganizationSettingsLoading (state, loading) {
    state.organizationSettingsLoading = loading
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};